import ToastHighLighter from '@/lib/ToastHighLighter';

export const FormUploadCode = () => {
  const language = 'html';
  const codeString = `
  // Form upload
  <div class="mb-3">
    <label htmlFor="formFile" class="form-label">
      Default file input example
    </label>
    <input class="form-control" type="file" id="formFile" />
  </div>
  <div class="mb-3">
    <label htmlFor="formFileMultiple" class="form-label">
      Multiple files input example
    </label>
    <input
      class="form-control"
      type="file"
      id="formFileMultiple"
      multiple
    />
  </div>
  <div class="mb-3">
    <label htmlFor="formFileDisabled" class="form-label">
      Disabled file input example
    </label>
    <input
      class="form-control"
      type="file"
      id="formFileDisabled"
      disabled
    />
  </div>
  <div class="mb-3">
    <label htmlFor="formFileSm" class="form-label">
      Small file input example
    </label>
    <input
      class="form-control form-control-sm"
      id="formFileSm"
      type="file"
    />
  </div>
  <div>
    <label htmlFor="formFileLg" class="form-label">
      Large file input example
    </label>
    <input
      class="form-control form-control-lg"
      id="formFileLg"
      type="file"
    />
  </div>
`;

  return (
    <>
      <ToastHighLighter
        name={'formupload'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
